import React, { FC } from 'react'
import { Pagination, PaginationProps } from '@mui/material'

const EvtPagination: FC<PaginationProps> = ({ ...props }) => {
    return <Pagination {...props} />
}

export default EvtPagination
